// Angular
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
// Components
import { BaseComponent } from "./views/theme/base/base.component";
import { ErrorPageComponent } from "./views/theme/content/error-page/error-page.component";
import { AuthGuard } from "./auth.guard";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { AdminAuthGuard } from "./admin-auth-guard";
// Auth

// const role = this.checkAdminRole() ? 'des-admin' : 'dashboard'
const routes: Routes = [
	{
		path: "auth",
		loadChildren: () =>
			import("../app/views/pages/auth/auth.module").then(
				(m) => m.AuthModule
			),
	},

	{
		path: "",
		component: BaseComponent,
		children: [
			{
				path: "dashboard",
				loadChildren: () =>
					import(
						"../app/views/pages/dashboard/dashboard.module"
					).then((m) => m.DashboardModule),
				canActivate: [AuthGuard],
			},
			{
				path: "usaid",
				loadChildren: () =>
					import("../app/views/pages/ehsaas/ehsaas.module").then(
						(m) => m.EhsaasModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "loa",
				loadChildren: () =>
					import("../app/views/pages/loa/loa.module").then(
						(m) => m.LoaModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "psl",
				loadChildren: () =>
					import("../app/views/pages/psl/psl.module").then(
						(m) => m.PslModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "pbs",
				loadChildren: () =>
					import("../app/views/pages/pbs/pbs.module").then(
						(m) => m.PbsModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "cafc",
				loadChildren: () =>
					import("../app/views/pages/cafc/cafc.module").then(
						(m) => m.CafcModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "sesp",
				loadChildren: () =>
					import("../app/views/pages/sesp/sesp.module").then(
						(m) => m.SespModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "wcp",
				loadChildren: () =>
					import("../app/views/pages/pmws/pmws.module").then(
						(m) => m.PmwsModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "osp",
				loadChildren: () =>
					import("../app/views/pages/osp/osp.module").then(
						(m) => m.OspModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "hsp",
				loadChildren: () =>
					import("../app/views/pages/hsp/hsp.module").then(
						(m) => m.HspModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "crhespb",
				loadChildren: () =>
					import("../app/views/pages/crhespb/crhespb.module").then(
						(m) => m.CrhespbModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "lgsp",
				loadChildren: () =>
					import("./views/pages/lgsp/lgsp.module").then(
						(m) => m.LgspModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "fdp-app",
				loadChildren: () =>
					import("../app/views/pages/fdp/fdp.module").then(
						(m) => m.FdpModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "feedback",
				loadChildren: () =>
					import("../app/views/pages/feedback/feedback.module").then(
						(m) => m.FeedbackModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "notifications",
				loadChildren: () =>
					import(
						"../app/views/pages/notifications-list/notification-list.module"
					).then((m) => m.NotificationListModule),
				canActivate: [AuthGuard],
			},
			{
				path: "profile",
				// canActivate: [AuthGuard],
				loadChildren:
					"../app/views/pages/profile/profile.module#ProfileModule",
			},
			{
				path: "error/403",
				component: ErrorPageComponent,
				data: {
					type: "error-v6",
					code: 403,
					title: "403... Access forbidden",
					desc: "Looks like you don't have permission to access for requested page.<br> Please, contact administrator",
				},
			},
			{
				path: "puca-app",
				loadChildren: () =>
					import("../app/views/pages/puca/puca.module").then(
						(m) => m.PucaModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "indigenous",
				loadChildren: () =>
					import("../app/views/pages/i500/i500.module").then(
						(m) => m.I500Module
					),
				canActivate: [AuthGuard],
			},
			{
				path: "irsip-app",
				loadChildren: () =>
					import("../app/views/pages/irsip/irsip.module").then(
						(m) => m.IrsipModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "irsip",
				loadChildren: () =>
					import("../app/views/pages/irsip/irsip.module").then(
						(m) => m.IrsipModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "ipfp-app",
				loadChildren: () =>
					import("../app/views/pages/ipfp/ipfp.module").then(
						(m) => m.IpfpModule
					),
				canActivate: [AuthGuard],
			},
			{
				path: "announcements",
				loadChildren: () =>
					import(
						"../app/views/pages/announcements/announcements/announcements.module"
					).then((m) => m.AnnouncementsModule),
				canActivate: [AuthGuard],
			},
			{
				path: "bfap-app",
				loadChildren: () =>
					import("../app/views/pages/bfap/bfap.module").then(
						(m) => m.BfapModule
					),
				canActivate: [AuthGuard],
			},
			// {
			// 	path: 'admin-dashboard',
			// 	loadChildren: () => import('../app/views/pages/admin/admin.module').then(m => m.AdminModule),
			// 	canActivate: [AdminAuthGuard],

			// },
			{ path: "error/:type", component: ErrorPageComponent },
			{ path: "", redirectTo: "dashboard", pathMatch: "full" },
			{ path: "**", redirectTo: "dashboard", pathMatch: "full" },
		],
	},
	{ path: "**", redirectTo: "error/403", pathMatch: "full" },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule],
	providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
})
export class AppRoutingModule {
	// checkAdminRole (): boolean  {
	// 	if(localStorage.getItem('esp-profile-details')){
	// 	let d = JSON.parse(decrypt(localStorage.getItem('esp-profile-details')))
	// 	const roleList = d.getSpRole
	// 	return roleList.some(role => {
	// 			return (role[1] == HEC_CONSTANTS.UserRoles.ASSISTANT || role[1] == HEC_CONSTANTS.UserRoles.FINANCE
	// 					|| role[1] == HEC_CONSTANTS.UserRoles.AD || role[1] == HEC_CONSTANTS.UserRoles.DD
	// 					|| role[1] == HEC_CONSTANTS.UserRoles.DIR || role[1] == HEC_CONSTANTS.UserRoles.ED)
	// 	});
	// }
	// }
}
